import { useAuth0 } from 'app/Auth'
import { useMutation, useQuery } from 'react-query'
import { axiosInstanceWallet } from '../../../services/config/axios-config'

// Interface for surgery pass request
export interface SurgeryPassParams {
  patientId: string
  surgeryId: string
}

/**
 * Hook to create a surgery pass
 */
export const useCreateSurgeryPass = () => {
  const { getAccessToken } = useAuth0()

  const mutation = useMutation<any, Error, SurgeryPassParams>(
    async (params: SurgeryPassParams) => {
      const token = await getAccessToken()
      const response = await axiosInstanceWallet.post(
        '/surgery_passes',
        {
          patientId: params.patientId,
          surgeryId: params.surgeryId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    }
  )

  return mutation
}

/**
 * Hook to fetch surgery pass data
 */
export const useGetSurgeryPass = (
  patientId: string,
  surgeryId: string,
  options = {}
) => {
  const { getAccessToken } = useAuth0()

  return useQuery(
    ['surgeryPass', patientId, surgeryId],
    async () => {
      const token = await getAccessToken()
      const response = await axiosInstanceWallet.get(
        `/surgery_passes/${patientId}/${surgeryId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    },
    {
      enabled: !!patientId && !!surgeryId,
      ...options,
    }
  )
}

/**
 * Get wallet pass preview URL for Apple or Google wallet
 */
export async function downloadWalletPass(
  patientId: string,
  surgeryId: string,
  walletType: 'apple' | 'google',
  getAccessTokenFn: () => Promise<string>
) {
  const token = await getAccessTokenFn()
  const endpoint = walletType === 'apple' ? 'apple' : 'google'

  const response = await axiosInstanceWallet.get(
    `/surgery_passes/${patientId}/${surgeryId}/${endpoint}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )

  return response.data.url
}
